<template>
    <div>
        <div>
            <v-text-field ref="enterPassword" :readonly="confirmPassword.trim().length > 0" counter v-model="model"
                :append-inner-icon="showPassword === true ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append-inner="clickShowPassword"
                :type="showPassword == true ? 'text' : 'password'"
                v-on:keyup="checkPassword" prepend-inner-icon="mdi-lock-outline" variant="outlined" 
                density="comfortable">
                <template v-slot:label>
                    <LanguagePlaceholder
                        default-text="Enter your password" />
                </template>
            </v-text-field>
            <v-text-field clearable @click:clear="clickClear" class="mt-2" counter v-model="confirmPassword"
                prepend-inner-icon="mdi-lock-outline" variant="outlined" 
                :append-inner-icon="showConfirmPassword === true ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append-inner="clickShowConfirmPassword"
                :type="showConfirmPassword == true ? 'text' : 'password'"
                density="comfortable">
                <template v-slot:label>
                    <LanguagePlaceholder 
                        default-text="Re-enter your password" />
                </template>
            </v-text-field>

            <v-sheet class="mt-3 mb-3 elevation-1" rounded
                :style="{ width: progress, height: '5px', transition: 'width 150ms' }" :class="classObject"></v-sheet>
            <v-sheet class="mb-4">
                <u style="font-size: 11px; text-decoration: none;">
                    <li v-for="o in messages">{{ o }}</li>
                </u>
            </v-sheet>
        </div>
    </div>


</template>

<script setup>
import { ref, onMounted, computed, watch, watchEffect, nextTick } from 'vue'
import router from '../router'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const model = defineModel()
const emit = defineEmits(['passwordValidated'])
const confirmPassword = ref('')
const systemStore = useSystemStore()
const enterPassword = ref()

const props = defineProps({
    minCharacters: { type: Number, default: 8 },
    innerIcon: { type: String, default: '' },
    placeHolder: { type: String, default: '' },
    label: { type: String, default: '' },
})

const validatePassword = (result) => {
    emit('passwordValidated', result)
}

watch(
    () => props.model, (val) => {
        // console.log(val)
    }
)
watchEffect(
    () => {
        // console.log(props.model)
    }
)

watch(confirmPassword, () => {
    checkPassword()
  }
)


const minCharacters = ref(0)
const innerIcon = ref('')
const placeHolder = ref('')
const label = ref('')
const showPassword = ref(false)
const showConfirmPassword = ref(false)

const mustContainUppercase = ref(true)
const mustContainLowercase = ref(true)
const mustContainNumber = ref(true)
const mustContainSpecialCharacter = ref(true)

const messages = ref([])
const strength = ref(0)


const clickShowPassword = () => {
    showPassword.value = !showPassword.value
}

const clickShowConfirmPassword = () => {
    showConfirmPassword.value = !showConfirmPassword.value
}

onMounted(() => {
    minCharacters.value = props.minCharacters
    innerIcon.value = props.innerIcon
    placeHolder.value = props.placeHolder
    label.value = props.label
})

const classObject = computed(() => ({
    'progress-bar-danger': strength.value <= 2,
    'progress-bar-warning': strength.value > 2 && strength.value < 5,
    'progress-bar-success': strength.value == 5,
}))

const clickClear = () => {
    strength.value = 0
    messages.value = []
    model.value = ''
    confirmPassword.value = ''
    validatePassword(false)
    nextTick(() => {
        enterPassword.value.focus()
    });

}

const progress = computed(() => {

    if (strength.value == 0) {
        return '0%'
    }
    if (strength.value == 1) {
        return '10%'
    }
    if (strength.value == 2) {
        return '30%'
    }
    if (strength.value == 3) {
        return '60%'
    }
    if (strength.value == 4) {
        return '80%'
    }
    if (strength.value == 5) {
        return '100%'
    }
})

const checkPassword = () => {
    strength.value = 0
    messages.value = []

    if (model.value.length >= minCharacters.value) {
        strength.value += 1;
    } else {
        messages.value.push('Minimum number of characters is ' + minCharacters.value)
    }

    if (mustContainLowercase.value && model.value.match(/[a-z]+/)) {
        strength.value += 1;
    } else {
        messages.value.push('Password must contain atleast 1 lower case letter.')
    }
    if (model.value.match(/[A-Z]+/)) {
        strength.value += 1;
    } else {
        messages.value.push('Password must contain atleast 1 upper case letter.')
    }
    if (model.value.match(/[0-9]+/)) {
        strength.value += 1;
    } else {
        messages.value.push('Password must contain atleast 1 numeric value.')
    }

    if (model.value.match(/[!@$%_]+/)) {
        strength.value += 1;
    } else {
        messages.value.push('Password must contain atleast 1 of the following special characters: !@$%_')
    }

    if (model.value.match(/[#]+/)) {
        strength.value -= 1;
        messages.value.push('Password contains character #. Password must only contain atleast 1 of the following special characters: !@$%_')

    } 

    if (confirmPassword.value.length != model.value.length) {
        messages.value.push('The passwords are not the same length.')
        validatePassword(false)
    } else {
        if ((confirmPassword.value == model.value) && model.value.trim().length > 0 ) {
            if (strength.value == 5){
                validatePassword(true)
            } else {
                validatePassword(false)   
            }
            
        } else {
            messages.value.push('The passwords do not match.')
            validatePassword(false)
        }
    }
}




</script>
<style scoped>
.progress-bar-danger {
    background-color: #e90f10;
}

.progress-bar-warning {
    background-color: #ffad00;
}

.progress-bar-success {
    background-color: #02b502;
}
</style>